import { Tabs, Tab, Container } from "react-bootstrap";

import Subheader from "components/Subheader";

import IndexedTabContent from "./components/IndexedTabContentSite";
import siteData from "./data/sites.json";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const calc_letters = LETTERS.filter((letter) =>
  siteData.some((site) => site.page.startsWith(letter)),
);

export default function SiteMap() {
  return (
    <>
      <Subheader pageName={"Site Map"} />
      <Container className="mb-5 py-3">
        <div className="p-4 border-bottom border-dark">
          <h4 className="text-uppercase fw-bold pb-3">
            Home -{" "}
            <span className="text-uppercase fw-bold text-primary">
              Site Index
            </span>
          </h4>
        </div>
        <div className="p-4">
          <h4 className="text-uppercase fw-bold pb-3">Browse the A-Z Index</h4>
          <Tabs defaultActiveKey="A" id="defintions-tabs" className="m-3">
            {calc_letters.map((letter) => (
              <Tab
                className="pb-5"
                eventKey={letter}
                title={letter}
                key={letter}
              >
                <IndexedTabContent index={letter} data={siteData} />
              </Tab>
            ))}
            <Tab className="pb-5" eventKey="All" title="All">
              <IndexedTabContent index="All" data={siteData} />
            </Tab>
          </Tabs>
        </div>
      </Container>
    </>
  );
}
